export default "__VITE_ASSET__CW5n$ZFS__"